export const QUERY_KEY_PILOTAGE_EFFECTIF = "pilotage_rh_effectif";
export const QUERY_KEY_PILOTAGE_DIVERSITE = "pilotage_rh_diversite";
export const QUERY_KEY_PILOTAGE_RETENTION = "pilotage_rh_retention";
export const QUERY_KEY_PILOTAGE_MOUVEMENTS = "pilotage_rh_mouvements";
export const QUERY_KEY_PILOTAGE_ABSENTEISME = "pilotage_rh_absenteisme";
export const QUERY_KEY_PILOTAGE_TEMPS_TRAVAIL = "pilotage_rh_temps_travail";
export const QUERY_KEY_PILOTAGE_FRAIS = "pilotage_rh_frais";
export const QUERY_KEY_PILOTAGE_TACHES = "pilotage_rh_taches";
export const QUERY_KEY_PILOTAGE_INDICATORS = "pilotage_rh_indicators";
